"use client"

import { FONT_SANS } from "@/lib/constants"

export const inputStyle: React.CSSProperties = {
  width: "100%",
  background: "var(--ljs-surface)",
  border: "1px solid var(--ljs-border)",
  borderRadius: 8,
  padding: "11px 14px",
  fontFamily: FONT_SANS,
  fontSize: 14,
  color: "var(--ljs-text)",
  outline: "none",
  boxSizing: "border-box",
}

export const labelStyle: React.CSSProperties = {
  fontFamily: FONT_SANS,
  fontSize: 13,
  fontWeight: 600,
  color: "var(--ljs-text-muted)",
  display: "block",
  marginBottom: 6,
}

export const errorTextStyle: React.CSSProperties = {
  fontSize: 11,
  color: "#EF4444",
  margin: "4px 0 0",
}

interface TextFieldProps {
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  error?: string
  hint?: string
  type?: string
  autoComplete?: string
}

export function TextField({
  label,
  value,
  onChange,
  placeholder,
  error,
  hint,
  type = "text",
  autoComplete,
}: TextFieldProps) {
  return (
    <div>
      <label style={labelStyle}>{label}</label>
      <input
        style={{
          ...inputStyle,
          borderColor: error ? "#EF4444" : "var(--ljs-border)",
        }}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
      {error && <p style={errorTextStyle}>{error}</p>}
      {hint && (
        <p style={{ fontSize: 11, color: "var(--ljs-text-faint)", margin: "4px 0 0" }}>{hint}</p>
      )}
    </div>
  )
}
